import { useEffect, useState } from 'react';

interface IStrongPassword {
  password: string;
  getStatus?: any;
}

export function StrongPassword({ password, getStatus }: IStrongPassword) {
  const [isStrong, setIsStrong] = useState(false);
  const [isMedium, setIsMedium] = useState(false);
  const [islow, setIslow] = useState(false);
  const [notInitialized, setNotInitialized] = useState(true);

  const strongPassword = new RegExp(
    '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})'
  );

  const mediumPassword = new RegExp(
    '((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))'
  );

  useEffect(() => {
    strengthChecker(password);
  }, [password]);

  useEffect(() => {
    if (getStatus) {
      getStatus(isStrong);
    }
  });

  function strengthChecker(PasswordParameter: string) {
    if (PasswordParameter !== '') {
      if (strongPassword.test(PasswordParameter)) {
        setIsStrong(true);
        setIslow(false);
        setIsMedium(false);
        setNotInitialized(false);
      } else if (mediumPassword.test(PasswordParameter)) {
        setIsMedium(true);
        setIslow(false);
        setIsStrong(false);
        setNotInitialized(false);
      } else {
        setIslow(true);
        setIsStrong(false);
        setIsMedium(false);
        setNotInitialized(false);
      }
    } else {
      setIslow(false);
      setIsStrong(false);
      setIsMedium(false);
      setNotInitialized(true);
    }
  }

  return (
    <>
      <div className="d-grid">
        <ul>
          <li className="color-text">Utilize letras maiúsculas</li>
          <li className="color-text">Utilize letras minúsculas</li>
          <li className="color-text">Utilize caracteres especiais</li>
          <li className="color-text">Utilize números</li>
        </ul>
        <span
          className={`text-center badge ${
            notInitialized ? 'text-bg-secondary' : ''
          } ${islow ? 'text-bg-danger' : ''} ${
            isMedium ? 'text-bg-warning' : ''
          } ${isStrong ? 'text-bg-success' : ''}`}
        >
          {notInitialized ? 'Crie uma senha forte' : ''}
          {islow ? 'Senha fraca' : ''}
          {isMedium ? 'Senha moderada' : ''}
          {isStrong ? 'Senha forte' : ''}
        </span>
        <p className="mt-3 mb-0 fw-semibold">Não sabe como criar?</p>
        <a
          href="https://www.avast.com/pt-br/random-password-generator#pc"
          target="_blank"
          className="d-flex"
        >
          <i className="material-icons me-2">link</i>Avast criação de senhas
        </a>
      </div>
    </>
  );
}
